import React from "react";
import { MapPin, Phone, Navigation, Clock, Sun } from "lucide-react";
import { Reveal } from "./Reveal";
import { BUSINESS } from "../data";

export const Location = () => (
  <section
    id="location"
    data-testid="location-section"
    className="relative py-24 md:py-32 scroll-mt-20"
  >
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="max-w-3xl">
        <Reveal>
          <p className="mb-5 inline-flex items-center gap-2 text-xs sm:text-sm tracking-[0.2em] uppercase font-bold text-neon">
            <span className="h-px w-8 bg-neon" /> 04 — Visit Us
          </p>
        </Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display font-black text-3xl sm:text-4xl md:text-5xl tracking-tight leading-tight">
            Find MEGAWIN5K in Jakarta
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid lg:grid-cols-5 gap-6">
        {/* Map */}
        <Reveal className="lg:col-span-3">
          <div
            data-testid="location-map"
            className="relative h-[24rem] lg:h-full min-h-[24rem] rounded-3xl overflow-hidden border border-white/10"
          >
            <iframe
              title="MEGAWIN5K location on Google Maps"
              src={BUSINESS.mapsEmbed}
              className="w-full h-full map-dark"
              style={{ border: 0 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </div>
        </Reveal>

        {/* Details + Hours */}
        <div className="lg:col-span-2 flex flex-col gap-6">
          <Reveal delay={0.08}>
            <div className="glass rounded-3xl p-8 border-white/10" data-testid="location-details">
              <div className="flex items-start gap-4">
                <MapPin size={22} className="text-neon shrink-0 mt-1" strokeWidth={1.5} />
                <div>
                  <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40">
                    Address
                  </p>
                  <p className="mt-2 text-white/85 leading-relaxed">
                    {BUSINESS.addressFull}
                  </p>
                </div>
              </div>
              <div className="mt-6 flex items-start gap-4">
                <Phone size={22} className="text-neon shrink-0 mt-1" strokeWidth={1.5} />
                <div>
                  <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40">
                    Phone
                  </p>
                  <a
                    href={BUSINESS.callLink}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid="location-phone-link"
                    className="mt-2 inline-block text-white/85 hover:text-neon transition-colors duration-200"
                  >
                    {BUSINESS.phoneDisplay}
                  </a>
                </div>
              </div>
              <a
                href={BUSINESS.directions}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="location-directions-btn"
                className="group mt-8 inline-flex w-full items-center justify-center gap-2 rounded-full bg-neon text-black font-bold px-8 py-4 hover:shadow-[0_0_30px_rgba(0,240,255,0.6)] transition-shadow duration-300 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white"
              >
                <Navigation size={18} className="transition-transform duration-300 group-hover:rotate-45" />
                Get Directions
              </a>
            </div>
          </Reveal>

          {/* Opening hours */}
          <Reveal delay={0.14}>
            <div className="glass rounded-3xl p-8 border-white/10" data-testid="opening-hours-card">
              <div className="flex items-center gap-3">
                <Clock size={22} className="text-violet" strokeWidth={1.5} />
                <p className="text-xs tracking-[0.2em] uppercase font-bold text-white/40">
                  Opening Hours
                </p>
              </div>
              <div className="mt-6 flex items-center justify-between">
                <span className="flex items-center gap-2 text-white/70">
                  <Sun size={16} className="text-neon" /> Opens at
                </span>
                <span className="font-display font-black text-2xl text-white">
                  {BUSINESS.opens}
                </span>
              </div>
              <div className="mt-4 pt-4 border-t border-white/10 text-sm text-white/50">
                Typically busiest around{" "}
                <span className="text-white font-semibold">{BUSINESS.busy}</span>.
                Detailed weekly hours may vary — please call ahead to confirm.
              </div>
            </div>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);
